import { Heading, CloseButton, Button, Modal } from '@smarterservices/smarter-ui';


const ConfirmReviewExitModal = (props) => {
  return (
    <Modal
      open={props.show}
      onDismiss={() => props.onCancel()}
      label="Stop Reviewing Session?"
      shouldCloseOnDocumentClick
      mountNode={() => document.getElementById('FocusModeContainer')}
      insertAt="top"
      constrain="parent"
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => props.onCancel()}
          screenReaderLabel="Close"
        />
        <Heading>Stop Reviewing Session?</Heading>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to stop reviewing this session?

      </Modal.Body>
      <Modal.Footer>
        <Button color="primary" type="submit" onClick={() => props.onConfirmation()}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmReviewExitModal;
